import { createFileRoute } from "@tanstack/react-router";
import { RabeloPage } from "@/paginas/rabelo";

const TITULO = "Rabelo — Milky Moo Palmares";
const DESCRICAO = "Leitura dos primeiros registros da tabela ponto no banco MySQL rabelo2.";

export const Route = createFileRoute("/_authenticated/rabelo")({
  head: () => ({
    meta: [
      { title: TITULO },
      { name: "description", content: DESCRICAO },
      { property: "og:title", content: TITULO },
      { property: "og:description", content: DESCRICAO },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RabeloPage,
});
